// Venue-search VS1.5: words on the venue page that are not field labels.
// Approved by Braeden in the VS1.5 plan (2026-11-03). Field labels and "?"
// definitions come from the field dictionary (src/taxonomy).
const plural = (n, one, many) => `${n.toLocaleString('en-US')} ${n === 1 ? one : many}`;

const copy = {
  showDefinition: (label) => `What is "${label}"?`,
  perDay: ' / day',
  hours: (n) => `(${plural(n, 'hour', 'hours')})`,
  basics: {
    title: 'The basics',
    guests: 'Guests',
    guestsTotal: (n) => `Up to ${n.toLocaleString('en-US')}`,
    insideSpace: 'Inside space',
    outsideSpace: 'Outside space',
    sqft: (n) => `${n.toLocaleString('en-US')} sq ft`,
    parking: 'Parking',
    parkingTotal: (n) => plural(n, 'space', 'spaces'),
    shuttleYes: 'The venue provides a shuttle from off-site parking.',
    shuttleNo: 'Plan a shuttle for guests who park off-site.',
    restrooms: 'Restrooms',
    restroomsTotal: (n) => plural(n, 'toilet', 'toilets'),
    restroomLabels: { 'restrooms.womens': "Women's", 'restrooms.mens': "Men's", 'restrooms.singleUser': 'Single-user' },
    kitchen: 'Kitchen',
    overnight: 'Overnight stay',
    yes: 'Yes',
    no: 'No',
    beds: 'Beds',
    showers: 'Showers',
    overnightNote: 'Book two days to include the night.'
  },
  features: { title: 'Features' },
  included: {
    title: "What's included",
    seeAll: (n) => `See all ${n} items`,
    showFewer: 'Show fewer'
  },
  rent: {
    title: 'Available to rent',
    note: 'These items cost extra.',
    ask: 'Ask about rentals →',
    subject: (venue) => `Rentals at ${venue}`,
    body: (venue) => `Venue: ${venue}\nItems I want to rent:\nEvent date:\n`
  },
  rules: {
    title: 'Rules',
    allowed: 'Allowed',
    notAllowed: 'Not allowed',
    allowedUntil: (time) => `Allowed until ${time}`,
    labels: {
      'rules.alcohol': 'Alcohol',
      'rules.amplifiedMusic': 'Loud music',
      'rules.dogs': 'Dogs',
      'rules.fire': 'Sparklers and open flame'
    },
    eventTypesNotAllowed: 'Event types not allowed'
  }
};

export default copy;
